import React, { useMemo } from 'react'
import {
  Table,
  Box,
  TextHeading,
  Space,
  useMediaSize,
} from '@ally/metronome-ui'
import styled from 'styled-components'
import { isAutoAccountWithNoActiveVehicle } from './utils'
import { getColumns } from './TableColumns'
import { useCustomizeDashboard } from '../CustomizeDashboard/CustomizeDashboardContext'
import { DashboardView } from '../CustomizeDashboard/types'
import CustomizeModalTrigger from '../CustomizeDashboard/CustomizeModalTrigger'
import AccountGroup from '../Shared/AccountGroup'
import AccountCard from '../Shared/AccountCard'
import { useAccountTypes } from '../AccountTypeContext'

import MobileVehicleAccountList from '../Shared/MobileAccountsCard/MobileVehicleAccountList'
import { VehicleAccountWell } from './VehicleAccountWell'
import NoActiveAccounts from './NoActiveAccounts'

const InvisibleForPrint = styled(Box)`
  @media print {
    visibility: hidden;
  }
`

const Vehicles: React.FC = () => {
  const { allAutoAccounts, isAutoUser } = useAccountTypes()
  const isMdDown = useMediaSize('MdDown')
  const isLgDown = useMediaSize('LgDown')

  const showCustomizationTrigger = useMediaSize('LgUp')
  const isPrint = window.matchMedia('print').matches
  const [{ dashboardView }] = useCustomizeDashboard()

  const isDefaultView = dashboardView === DashboardView.DEFAULT || isLgDown

  const isAllAutoAccountsWithNoActiveVehicle = useMemo(
    () =>
      allAutoAccounts.every(account =>
        isAutoAccountWithNoActiveVehicle(account),
      ),
    [allAutoAccounts],
  )

  return isAutoUser ? (
    <>
      <Box
        mb="sm"
        ml={showCustomizationTrigger ? '-18px' : '0'}
        display="flex"
        alignItems="center"
      >
        {showCustomizationTrigger ? (
          <InvisibleForPrint>
            <CustomizeModalTrigger lob="auto" triggerIsIcon />
          </InvisibleForPrint>
        ) : null}
        <Space mr="sm">
          <TextHeading
            tag="h2"
            size="md"
            tabIndex={-1}
            white-space="nowrap"
            min-width="30%"
          >
            Vehicles
          </TextHeading>
        </Space>
      </Box>
      {isAllAutoAccountsWithNoActiveVehicle ? (
        <NoActiveAccounts />
      ) : (
        <AccountGroup name="vehicles">
          <AccountCard type="auto">
            {isMdDown && !isPrint ? (
              <MobileVehicleAccountList accounts={allAutoAccounts} />
            ) : (
              <>
                {allAutoAccounts.length && (
                  <Table
                    data={allAutoAccounts}
                    columns={getColumns({ isDefaultView })}
                    captionText="Information about your Ally Vehicle accounts"
                    fullWidth
                    suppressMdDownLayout
                    withFooter
                  />
                )}
              </>
            )}
            <VehicleAccountWell />
          </AccountCard>
        </AccountGroup>
      )}
    </>
  ) : null
}

export default Vehicles
